module.exports = __webpack_public_path__ + "static/media/group_25.eef6f83c.jpg";